import { useEffect, useRef } from 'react';
export function useInfinityScrollObserver({ hasNextPage, isFetching, fetchNextPage }) {
    const sentinelRef = useRef(null);
    useEffect(() => {
        if (!sentinelRef.current || !hasNextPage || isFetching) {
            return () => { };
        }
        const observer = new IntersectionObserver(entries => {
            const [entry] = entries;
            if (entry.isIntersecting && hasNextPage && !isFetching) {
                fetchNextPage();
            }
        }, {
            threshold: 0.1
        });
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [hasNextPage, isFetching, fetchNextPage]);
    return { sentinelRef };
}
//# sourceMappingURL=use-infinity-scroll-observer.hook.js.map